import { getError } from "@/utils/helpers";
import StatuteMeetingService from "@/services/statute/StatuteMeetingService";

export const namespaced = true;

export const state = {
  meetings: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_MEETINGS(state, meetings) {
    state.meetings = meetings;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getMeetings({ commit }, famId) {
    commit("SET_LOADING", true);

    StatuteMeetingService.getMeetings(famId)
      .then((response) => {
        commit("SET_MEETINGS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_MEETINGS", []);
  },
};
export const getters = {
  meetings: (state) => {
    return state.meetings;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
